import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import { Typography } from '@material-ui/core';
import {
  identityApiRef,
  ProfileInfo,
  useApi,
} from '@backstage/core-plugin-api';
import { useRouteRef } from '@backstage/frontend-plugin-api';
import { parseEntityRef } from '@backstage/catalog-model';
import { entityRouteRef } from '@backstage/plugin-catalog-react';
import { ButtonLink } from '@backstage/ui';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';

export const BackstageProfileLink = () => {
  const identityApi = useApi(identityApiRef);
  const catalogRouteRef = useRouteRef(entityRouteRef);
  const [profileInfo, setProfileInfo] = useState<ProfileInfo | null>(null);
  const [userEntityRef, setUserEntityRef] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const [userProfile, backstageIdentity] = await Promise.all([
          identityApi.getProfileInfo().catch(() => null),
          identityApi.getBackstageIdentity(),
        ]);
        setProfileInfo(userProfile);
        setUserEntityRef(backstageIdentity.userEntityRef);
      } catch {
        setError(
          'Could not fetch your user identity. Please sign out from Settings and sign in again.',
        );
      }
    };

    fetchUserInfo();
  }, [identityApi]);

  if (error) {
    return (
      <Card variant="outlined" sx={{ width: '100%' }}>
        <Typography variant="body2" style={{ padding: 16 }}>
          {error}
        </Typography>
      </Card>
    );
  }

  if (!userEntityRef || !catalogRouteRef) {
    return null;
  }

  return (
    <ButtonLink
      href={catalogRouteRef(parseEntityRef(userEntityRef))}
      variant="secondary"
      iconStart={<UserSettingsSignInAvatar />}
    >
      {profileInfo?.displayName || 'Your Profile'}
    </ButtonLink>
  );
};
